import { Get, Post, Put } from "../Request/Api";

export default {
  state: { 
    Notification: [],
    UserNotifications: [],
    CheckUserMembershipExpiration: null,
  },
  getters: {
    GetNotification(state: any) {
      return state.Notification;
    },
    GetUserNotifications(state: any) {
      return state.UserNotifications;
    },
    GetCheckUserMembershipExpiration(state: any) {
      return state.CheckUserMembershipExpiration;
    },
  },
  actions: {
    async GetALLNotification({ commit } :any , payload :any ) {
      return await Get(`Notification/GetNotificationSettingByUserId?userId=${payload}`).then((res :any) => {
        return commit("SetAllNotification", res.data.Data);
      });
    },
    async GetAllUserNotifications({ commit } :any , payload :any ) {
      return await Get(`Notification/GetNotificationsByUserId?userId=${payload}`).then((res :any) => {
        return commit("SetAllUserNotifications", res.data.Data);
      });
    },
    async GetCheckUserMembershipExpiration({ commit } :any , payload :any ) {
      return await Get(`Membership/CheckUserMembershipExpiration?userId=${payload}`).then((res :any) => {
        return commit("SetCheckUserMembershipExpiration", res.data.Data);
      });
    },
    async updateNotification({ commit }: any, payload: any) {
      return await Post("Notification/PostNotificationSetting", payload).then(
        (res: any) => { 
          return res.data.Data;
        }
      );
    },
    async MarkAsReadNotification({ commit }: any, payload: any) {
      try {
        const body = {
          notificationID: payload.notificationID,
          userID: payload.userID,
        };
        const response = await Put("Notification/MarkNotificationAsRead", body);
        return response.data;
      } catch (error) {
        console.error("Error marking notification as read:", error);
        throw error;
      }
    },
    async DeleteUserNotification({ commit }: any, payload: any) {
      try {
        const body = {
          notificationID: payload.notificationID,
          userID: payload.userID,
        };
        const response = await Put("Notification/DeleteUserNotification", body);
        return response.data;
      } catch (error) {
        console.error("Error marking notification as read:", error);
        throw error;
      }
    },
    async MarkAllNotificationAsRead({ commit }: any, payload: any) {
      try {
        const body = {
          notificationIDs: payload.notificationIDs,
          userID: payload.userID,
        };
        const response = await Put("Notification/MarkAllNotificationAsRead", body);
        return response.data;
      } catch (error) {
        console.error("Error marking all notifications as read:", error);
        throw error;
      }
    }
  },
  mutations: {
    SetAllNotification(state :any, payload:any) {
      state.Notification= payload;
    },
    SetAllUserNotifications(state :any, payload:any) {
      state.UserNotifications= payload;
    },
    SetCheckUserMembershipExpiration(state :any, payload:any) {
      state.CheckUserMembershipExpiration= payload;
    },
  },
  
};
